module.exports = __webpack_public_path__ + "img/social_google.0c5b641d.png";